const B32 = '0123456789ABCDEFGHJKMNPQRSTVWXYZ'

let lastMs = -1
const rand: number[] = new Array(16).fill(0)

function fillRandom(): void {
  const c = (globalThis as { crypto?: { getRandomValues?: (a: Uint8Array) => Uint8Array } }).crypto
  if (c?.getRandomValues) {
    const bytes = c.getRandomValues(new Uint8Array(16))
    for (let i = 0; i < 16; i++) rand[i] = (bytes[i] ?? 0) & 31
  } else {
    for (let i = 0; i < 16; i++) rand[i] = Math.floor(Math.random() * 32)
  }
  // Headroom so same-ms increments cannot overflow the random part.
  rand[0] = (rand[0] ?? 0) & 15
}

function bump(): void {
  for (let i = 15; i >= 0; i--) {
    if ((rand[i] ?? 0) < 31) {
      rand[i] = (rand[i] ?? 0) + 1
      return
    }
    rand[i] = 0
  }
}

// Monotonic: within one ms (or if the clock steps back) the random part increments.
export function newId(now: number = Date.now()): string {
  if (now > lastMs) {
    lastMs = now
    fillRandom()
  } else {
    bump()
  }
  let t = lastMs
  let time = ''
  for (let i = 0; i < 10; i++) {
    time = B32[t % 32] + time
    t = Math.floor(t / 32)
  }
  let r = ''
  for (let i = 0; i < 16; i++) r += B32[rand[i] ?? 0]
  return time + r
}
